<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  message: { type: String, required: true },
  isLoading: { type: Boolean, default: false },
  framed: { type: Boolean, default: true },
});

const emit = defineEmits(['retry']);
const { t } = useI18n();
</script>

<template>
  <div
    role="alert"
    class="flex flex-wrap items-center justify-between gap-3 p-4"
    :class="{ 'rounded-lg border border-n-weak bg-n-surface-1': framed }"
  >
    <p class="mb-0 text-sm text-n-ruby-11">{{ message }}</p>
    <Button
      :label="t('ASSISTANT.RETRY')"
      icon="i-lucide-refresh-cw"
      color="slate"
      size="sm"
      class="min-h-11"
      :is-loading="isLoading"
      @click="emit('retry')"
    />
  </div>
</template>
